import { gql } from "graphql-request";
import graphQLClient from 'config/graphql-instance';
import { GQLGetOrderPartialProperties } from ".";

export const getOrderPartialProperties = async (
  payload: {
    id: string,
  }
) => {
  const query = gql`
    query GetOrder($id: ID!) {
      getOrder(_id: $id) {
        estates {
        _id
        address {
          _id
          address
          settlement
          }
        }
      }
    }
  `;
  const response = await graphQLClient()
    .request<GQLGetOrderPartialProperties>(query, payload);

  return response;
};
